package com.rabbitsign.web

import com.rabbitsign.web.util.hide
import com.rabbitsign.web.util.show
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLButtonElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement

@OptIn(ExperimentalJsExport::class)
@JsExport
@JsName("BatchSendPage")
object BatchSendPage : RabbitSignPage() {
    override fun runPage() {
        log.info("run")

        initializeNavbar()
        initializeInactivity()

        val tosModal = document.getElementById("RabbitSign-batchSend-tos-modal") as HTMLElement?
        if (tosModal != null) {
            jQuery(tosModal).modal()

            val acceptButton = document.getElementById("RabbitSign-batchSend-tos-modal-accept-button") as HTMLButtonElement?
            val acceptInput = document.getElementById("RabbitSign-batchSend-tos-modal-accept-input") as HTMLInputElement?
            if (acceptInput != null && acceptButton != null) {
                acceptButton.disabled = !acceptInput.checked
                acceptInput.addEventListener("input", { acceptButton.disabled = !acceptInput.checked })
            }
        }
    }

    // TODO: this could be merged with DeveloperPage version
    @JsName("recordTosAcceptance")
    fun recordTosAcceptance() {
        log.info("recordTosAcceptance")

        MainScope().launch {
            show("#spinnerOverlay")
            show("#fullPageSpinner")
            getApi().callEnableBatchSend()
            hide("#spinnerOverlay")
            hide("#fullPageSpinner")
            window.location.assign("/user/batch-send/payment")
        }
    }
}